import { render, staticRenderFns } from "./pkgType.vue?vue&type=template&id=79424368&"
import script from "./pkgType.vue?vue&type=script&lang=js&"
export * from "./pkgType.vue?vue&type=script&lang=js&"
import style0 from "./pkgType.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports